import React, { createContext } from 'react';
import { useNurseServiceBookingForm } from '../hooks/useNurseServiceBookingForm'

export const NurseServiceBookingFormContext = createContext(null);

export const NurseServiceBookingContextProvider = ({ children }) => {

    const nurseBookingFormContext = useNurseServiceBookingForm();

    return (
        <NurseServiceBookingFormContext.Provider value={nurseBookingFormContext}>
            {children}
        </NurseServiceBookingFormContext.Provider>
    )
}
